$(document).ready(function () {
    const sortActiveClass = 'sort__item_active';

    $('[data-sort]').click(function () {
        let element = $(this),
            value = element.data('sort'),
            input = $('[name="' + element.data('sort-input') + '"]'),
            order = element.attr('data-sort-order');

        if (order) {
            value += '|' + order;
            element.attr('data-sort-order', (order === 'asc') ? 'desc' : 'asc');
        }

        element.siblings().removeClass('desc ' + sortActiveClass).attr('data-sort-order', 'asc');

        if (element.hasClass(sortActiveClass)) {
            if (element.hasClass('desc')) {
                element.removeClass('desc ' + sortActiveClass);
                value = "";
                element.attr('data-sort-order', 'asc');
            }
            else
                element.addClass('desc');}
        else
            element.addClass(sortActiveClass);
        
        input.val(value).change();
    });
});